import { cn } from '@optools/components/ui/utils';

export interface SheetTitleSectionProps {
  children: React.ReactNode;
  className?: string;
  id: string;
  title: string;
}

export function SheetTitleSection({ children, className, id, title }: SheetTitleSectionProps) {
  return (
    <div className={cn('flex flex-col gap-1 whitespace-nowrap', className)}>
      <dt className="text-xs text-muted-foreground" id={id}>
        {title}
      </dt>
      <dd aria-labelledby={id} className="flex flex-1 items-center text-sm font-medium capitalize">
        {children}
      </dd>
    </div>
  );
}
